import {
    TAUSCHBONUS_INFO_CONTAINER_ID,
    TAUSCHBONUS_PROMOTIONAL_CARD_CONTAINER_ID,
    TRADEIN_HARDWARE_ONLY_NOTIFICATION_CONTAINER_ID,
    TRADEIN_INFO_CONTAINER_ID,
    TRADEIN_ITEM_SUMMARY_CARD_CONTAINER_ID,
    TRADEIN_OPTION_PICKER_CONTAINER_ID,
    TRADEIN_STATUS_NOTIFICATION_CONTAINER_ID,
    TRADEIN_SUGGEST_INPUT_CONTAINER_ID,
} from '../../app/constants';
import { mountButtonLinkForTauschbonus } from './components/ButtonLinkForTauschbonus';
import { mountButtonLinkForTradeIn } from './components/ButtonLinkForTradeIn';
import { mountTradeInFormSuggestInput } from './components/FormSuggestInput';
import { mountTradeInItemSummaryCard } from './components/ItemSummaryCard';
import { mountNotificationForHardwareOnly } from './components/NotificationForHardwareOnly';
import { mountNotificationForSuggestInputStatus } from './components/NotificationForSuggestInputStatus';
import { mountTradeInOptionPicker } from './components/OptionPickerForTradeIn';
import { mountTauschbonusPromotionalCard } from './components/PromotionalCardForTauschbonus';
import { startListeners } from './listeners';

/**
 * Init tradeIn
 */
export const initTradeIn = () => {
    startListeners();

    mountTauschbonusPromotionalCard(TAUSCHBONUS_PROMOTIONAL_CARD_CONTAINER_ID);
    mountTradeInOptionPicker(TRADEIN_OPTION_PICKER_CONTAINER_ID);
    mountTradeInFormSuggestInput(TRADEIN_SUGGEST_INPUT_CONTAINER_ID);
    mountTradeInItemSummaryCard(TRADEIN_ITEM_SUMMARY_CARD_CONTAINER_ID);
    mountNotificationForSuggestInputStatus(TRADEIN_STATUS_NOTIFICATION_CONTAINER_ID);
    mountNotificationForHardwareOnly(TRADEIN_HARDWARE_ONLY_NOTIFICATION_CONTAINER_ID);
    mountButtonLinkForTradeIn(TRADEIN_INFO_CONTAINER_ID);
    mountButtonLinkForTauschbonus(TAUSCHBONUS_INFO_CONTAINER_ID);
};
